import React from 'react';
import { principles } from '../../data/site';
import { Eyebrow } from '../ui/Eyebrow';
import { useBrand } from '../../contexts/BrandContext';
export function Principles() {
  const {
    brand
  } = useBrand();
  return <section className="bg-ink text-cream" data-id="element-94" data-mp="24sfq9oyn2xp5">
      <div className="mx-auto max-w-shell px-6 py-20 md:px-8 md:py-28" data-id="element-95" data-mp="24vv8h0nm0mus">
        <div className="grid gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-20" data-id="element-96" data-mp="28wngxronqnq0">
          <div data-id="element-97" data-mp="2dt5kwpc5yi1a">
            <Eyebrow className="text-cream/70" data-id="element-98" data-mp="2dtnpc98zc2ka">What {brand.name} stands on</Eyebrow>
            <p className="mt-6 font-serif text-4xl leading-[1.06] md:text-[3.5rem]" data-id="element-99" data-mp="2is8fffuip5v0">
              {brand.copy.manifesto}
            </p>
          </div>

          <ul className="flex flex-col divide-y divide-cream/20" data-id="element-100" data-mp="2sj3dril1fvwt">
            {principles.map(principle => <li key={principle.name} className="grid gap-2 py-6 first:pt-0 sm:grid-cols-[10rem_1fr] sm:gap-8" data-id="element-101" data-mp="2wkyeolz247a2">
                <h3 className="font-serif text-2xl text-cream" data-id="element-102" data-mp="31k1796xuol15">{principle.name}</h3>
                <p className="max-w-xl text-base leading-relaxed text-cream/75" data-id="element-103" data-mp="34yidw67p2vzx">
                  {principle.detail}
                </p>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}